import request from '@/utils/request'

export function getMaps() {
  return request({
    url: '/maps/availablemaps',
    method: 'post',
    // data: findRequest,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function getMapVisualization(query) {
  return request({
    url: '/maps/GetMapConfigById',
    method: 'post',
    data: query,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function GetMapFiltersData(query) {
  return request({
    url: '/maps/GetMapFiltersData',
    method: 'post',
    data: query,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
